// https://cognni.monday.com/boards/4137554527
type H_M_L = "high" | "medium" | "low";
type ProtectionTier = 0 | 1 | 2 | 3 | 4;

export type ScriptGroup =
  | "DLP"
  | "Data Protection"
  | "Insider Risk"
  | "information access"
  | "Information Governance";

export const ScriptGroupHelper = {
  list: [
    "DLP",
    "Data Protection",
    "identities security",
    "information access",
    "Information Governance",
  ],
};

export type ScriptThreat =
  | "Account Takeover"
  | "Unauthorized access"
  | "BEC"
  | "Data Theft"
  | "Data Lost"
  | "Malware Infections"
  | "Legal Risks"
  | "Insider Threat"
  | "Compliance Violation"
  | "Regulations"
  | "Data Leaks"
  | "Phishing"
  | "Data Breach";

export const ScriptThreatHelper = {
  list: [
    "Account Takeover",
    "Unauthorized access",
    "BEC",
    "Data Theft",
    "Data Lost",
    "Malware Infections",
    "Legal Risks",
    "Insider Threat",
    "Compliance Violation",
    "Regulations",
    "Data Leaks",
    "Phishing",
    "Data Breach",
  ],
};

export interface BaseAppScript {
  id: string;
  type: "cloud" | "powershell" | "policy";
  group: ScriptGroup;
  action: string;
  cascading_threats: ScriptThreat[];
  threats: ScriptThreat[];
  friction: H_M_L;
  protection_tier: ProtectionTier;
  reduce_risk: H_M_L;
  description: string;
  is_available: boolean;
  is_not_licensed?: boolean;
}

export interface AppScript extends BaseAppScript {
  details: string;
  mitigation: string;
  template: string;
  readme: string;
  predefined_vars: string[];
  script: string;
  undo_script: string;
  known_limitations: string;
}

export interface TemplateVar {
  id: string;
  name: string;
  with_variant?: string;
}

export type TemplateVarsMap = Record<string, TemplateVar[]>;
